import Footer from "../Footer/footer";
import Header from "../Header/header";
// import NamazTimings from "../NamazTimings/namazTimings";
import TazakuraatHighlight from "../Tazakurat/TazakuraatHighlights";
import OurBooksHighlight from "../Tableeghat/ourBooksHighlight";
import NoorDiaryHighlights from "../Tableeghat/noorDiaryHighlights";
import MunasibatHighlights from "../Munasibat/MunasibatHighlights";
import AajKiBaat from "./AajKiBaat";
import AMNTaaruf from "./AMNTaaruf";
import { useEffect, useState } from "react";
import { getMainPage } from "./_request";

export default function Home() {
  const [mainPageData, setMainPageData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getMainPage();
        if (response?.success) {
          setMainPageData(response.data);
        }
      } catch (error) {
        console.error("Error fetching main page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Header />
      {/* <NamazTimings /> */}
      <div
        dir="rtl"
        className="bg-white min-h-screen tracking-[0.05rem] lg:mt-20 md:mt-18 mt-8 lg:px-20 md:px-10 px-6 text-black text-center font-nastaleeqRegular"
      >
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
          </div>
        ) : (
          <>
            <AajKiBaat
              ayats={mainPageData?.ayats}
              heroImage={mainPageData?.mainPage?.heroImage}
            />
            <div className="px-5">
              <AMNTaaruf />
              {mainPageData?.mainPage?.jashans && (
                <MunasibatHighlights
                  jashans={mainPageData?.mainPage?.jashans}
                />
              )}
              <div className="mb-10" dir="ltr">
                            <NoorDiaryHighlights />
                        </div>
              <TazakuraatHighlight />
              <OurBooksHighlight />
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  );
}
